export default function IndexDropdown({ indexIds, value, onChange, label, placeholder }) {
	return (
		<div className="field-row">
			{label ? <label>{label}</label> : null}
			<select value={value || ""} onChange={(e) => onChange(e.target.value)} className="form-control">
				<option value="">{placeholder || "Select index..."}</option>
				{(indexIds || []).map((id) => (
					<option key={id} value={id}>{id}</option>
				))}
			</select>
		</div>
	);
}
